export default __webpack_public_path__ + "static/blob11-c4c3add3b600cd85780a527048db66c0.svg";